import IconButton from 'components/IconButton';
import history from 'history.js';
import { useAtomValue } from 'jotai';
import React, { useState } from 'react';

import AssetDetailsDialog from './AssetDetailsDialog';
import { policyIdFilterAtom as assetsPolicyIdFilterAtom } from './state';
import { getDrillDownUrl } from '../helper';

const RowActions = ({ rowData }) => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const assetsPolicyId = useAtomValue(assetsPolicyIdFilterAtom);

  const handleViewDetailsClick = () => {
    setIsDetailsModalOpen(true); // Open the modal
  };

  const handleCloseModal = () => {
    setIsDetailsModalOpen(false); // Close the modal
  };

  const hasFindings = rowData['failed_count'] + rowData['passed_count'] > 0;

  // Determine sourceType from row data (like CA approach)
  const rowSourceType = rowData['server_or_workstation']
    ? `ca_data__${rowData['server_or_workstation']}`
    : undefined;

  return (
    <div>
      <IconButton
        id="findingsLink"
        iconClass="fa fa-clipboard-list"
        size="sm"
        tooltip={hasFindings ? 'View Host Findings' : 'No Findings Available'}
        onClick={() =>
          history.push(
            getDrillDownUrl({
              policyId: assetsPolicyId,
              hosts_in: [rowData['host_id']],
              sourceType: rowSourceType,
            }),
          )
        }
        disabled={!hasFindings}
      />
      <IconButton
        id="assetDetailsLink"
        iconClass="fa fa-eye"
        size="sm"
        tooltip="View Details"
        onClick={handleViewDetailsClick} // Open modal on click
      />
      {isDetailsModalOpen && (
        <AssetDetailsDialog
          caId={rowData['id']} // Pass the ID to the modal
          isOpen={isDetailsModalOpen} // Control modal visibility
          onClose={handleCloseModal} // Close modal when done
        />
      )}
    </div>
  );
};

export default RowActions;
